"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.MINIAPP_PAGE_LIFECYCLE = exports.UNHANDLED_REJECTION = exports.TAB_ITEM_CLICK = exports.SHARE = exports.NOT_FOUND = exports.ERROR = exports.LAUNCH = exports.HIDE = exports.SHOW = void 0;
exports.SHOW = 'show';
exports.HIDE = 'hide';
exports.LAUNCH = 'launch';
exports.ERROR = 'error';
exports.NOT_FOUND = 'notfound';
exports.SHARE = 'share';
exports.TAB_ITEM_CLICK = 'tabitemclick';
exports.UNHANDLED_REJECTION = 'unhandledrejection';
exports.MINIAPP_PAGE_LIFECYCLE = (_a = {},
    _a[exports.SHOW] = 'miniapp_pageshow',
    _a[exports.HIDE] = 'miniapp_pagehide',
    _a);
